module.exports = __webpack_public_path__ + "static/img/eclipse.a86d190.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbnails/eclipse.svg
// module id = oNt2
// module chunks = 0